module.exports = __webpack_public_path__ + "static/media/customer-support-illustration.9811d9d3.svg";